<template>
  <div class="d-flex h-100 referral-editor" :class="{ 'with-sidebar': showSidebar }">
    <div class="ml-auto h-100" style="flex: 1">
      <Dropzone class="border-0 h-100" @drop="drop">
        <div class="card-body p-0 h-100">
          <ReferralLoader v-if="isLoading || !isPracticesLoaded || !isReferralsLoaded" :rounded="true" class="h-100" />
          <template v-else-if="!$route.params.to && (isCreateReferral || isNew)">
            <div v-if="false && !practiceDoctors.length">
              <div class="jumbotron">
                <h1>Almost there...</h1>
                <p class="lead">You have no active Doctors.</p>
                <p>To send referrals at least one Doctor needs to be added to your practice.</p>
                <small v-if="!user.is_office_admin">Only an office admin can add Doctors to this account.</small>
                <!--TODO: If Office Admin User - else, conact office admin-->
                <add-doctor v-else @added="() => $router.go()" style="max-width: 768px" class="mx-auto" />
                <!-- <a v-else href="javascript:void(0);" @click="isAddDoctor = !isAddDoctor" class="btn btn-primary btn-lg">Ok, Add a Doctor</a> -->
                <!-- <router-link v-else to="/manage/users" role="button" class="btn btn-primary btn-lg">Add a Doctor</router-link> -->
              </div>
            </div>
            <div v-else-if="!$route.params.to && practices.length === 0 && $route.query.force !== 'true'">
              <empty heading="Your network is empty" cta="Add referring office">
                <p>To send referrals at least one referring office needs to be added to your network.</p>
                <template v-slot:below>
                  <div class="d-block">
                    <router-link class="btn btn-link btn-lg btn-xl font-weight-bolder" to="/referral?force=true"
                      >Ignore, I just want to see the referral form</router-link
                    >
                  </div>
                </template>
              </empty>
            </div>
          </template>
          <div v-else-if="referralLoadError">
            <div class="alert alert-danger m-3">
              <span>Failed to load referrals. Please refresh and try again.</span>
            </div>
          </div>
          <ReferralNotFound v-else-if="isNotFound" />
          <div v-else-if="model.sent_time">
            <div class="alert alert-primary m-3">
              <span>Referral sent on {{ moment(model.sent_time).format('LL') }}.</span>
            </div>
          </div>
          <template v-else>
            <div class="d-flex h-100">
              <div
                class="view-referral-wrapper mx-auto flex-grow-1 h-100"
                style="background: var(--light-color); overflow-y: auto"
              >
                <div class="mx-auto" style="max-width: 1080px">
                  <div class="mx-auto p-5 pt-2" style="">
                    <form data-vv-scope="referral-form">
                      <div
                        class="referral-container bg-white mx-auto p-5 px-6 paper-shadow"
                        style="margin-bottom: 100px"
                        data-v-tour="createReferralContainer"
                      >
                        <div
                          class="practice-header d-flex align-items-center mb-5 row"
                          :class="{
                            'has-overlay': practice && !isChangePracticeShown && allowPracticeChange,
                          }"
                        >
                          <div
                            v-if="isAllowPracticeChange"
                            @click="isChangePracticeShown = true"
                            class="overlay-practice-header align-items-start justify-content-end"
                          >
                            <a href="javascript:void(0)" class="btn btn-outline-primary">Change Practice</a>
                          </div>
                          <div class="logo _mr-5 col-12 text-center _col-md-3">
                            <!-- TODO: Custom logos, pull from their favicon website -->
                            <img
                              v-if="practice && practice.logo"
                              :src="practice.logo"
                              class="img-fluid"
                              style="min-height: 75px; max-height: 100px"
                            />
                            <img v-else src="@/assets/svg/logo.svg" class="img-fluid" style="width: 128px" />
                          </div>
                          <div class="col mt-4 _mt-md-0 text-center _text-md-left" style="font-size: 1.175rem">
                            <input
                              type="hidden"
                              v-model="model.to_practice_id"
                              v-validate="'required'"
                              data-vv-scope="referral-form"
                              data-vv-as="Practice"
                              name="to_practice_id"
                            />
                            <template v-if="practice && !isChangePracticeShown">
                              <h1 v-if="practice && !practice.is_logo_only">{{ practice && practice.name }}</h1>
                              <span v-if="practice && practice.address">
                                <font-awesome-icon icon="map-marker-alt" class="text-primary mr-2" />
                                {{ $helpers.address(practice) }}
                              </span>
                              <span v-if="practice && practice.phone">
                                <br />
                                <font-awesome-icon icon="phone" class="text-primary mr-2" />
                                {{ practice.phone | phone }}
                              </span>
                            </template>
                            <div class="mx-auto" style="max-width: 480px" v-else>
                              <div class="d-flex">
                                <h6 class="w-100 d-flex">
                                  Practice<small
                                    v-if="errors.has('to_practice_id', 'referral-form')"
                                    class="invalid-feedback d-inline mt-0 ml-2 text-right font-weight-normal"
                                    >You must select a practice</small
                                  >
                                </h6>
                              </div>
                              <practice-auto-complete
                                v-model="model.to_practice_id"
                                @selected="changePractice"
                                :key="user.id"
                                style="font-size: 1rem"
                                :error="errors.has('to_practice_id', 'referral-form')"
                              />
                              <div class="d-flex mx-auto text-center mt-1">
                                <small v-if="practice">
                                  <a href="javascript:void(0)" @click="isChangePracticeShown = false" class="txt-link"
                                    >Go back</a
                                  ></small
                                >
                                <!-- <small v-if="!model.to_practice_id && practices.length > 5" class="ml-auto">
                                  <router-link to="/referral/find-office">Advanced search</router-link></small
                                > -->
                              </div>
                            </div>
                          </div>
                        </div>
                        <div style="font-weight: 500">
                          <div class="row mb-3">
                            <div class="col text-right">
                              {{ moment(model.sent_time || model.created_at).format('LL') }}
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-12 col-md-6">
                              <label class="d-flex">
                                Referring Doctor
                                <small class="ml-auto" v-if="!isPublic">
                                  <a
                                    href="javascript:void(0)"
                                    @click="isAddDoctor = !isAddDoctor"
                                    class="font-weight-bolder"
                                    >{{ !isAddDoctor ? '+ Add doctor' : 'Cancel' }}</a
                                  >
                                </small>
                              </label>
                              <!-- {{ model.referring_doctor_id || 'no ' }}
                              {{ practiceDoctors.find((s) => s.id == model.referring_doctor_id) || 'none' }} -->
                              <select
                                v-if="!isAddDoctor"
                                @change="referringDoctorChange"
                                class="form-control form-control-lg form-control-xl"
                                :disabled="!!model.sent_time"
                                v-model="model.referring_doctor_id"
                                name="referring_doctor_id"
                                v-validate="'required'"
                                data-vv-scope="referral-form"
                                data-vv-as="Referred From"
                                :key="practiceDoctors.map((s) => s.id).join('')"
                              >
                                <option v-if="practiceDoctors.length === 0" disabled value>No Doctors Available</option>
                                <option v-else-if="practiceDoctors.length > 1" disabled :value="null" hidden>
                                  - Select -
                                </option>
                                <option v-for="item in practiceDoctors" :value="item.id" :key="item.id">
                                  {{ $helpers.displayUsername(item) }}
                                </option>
                              </select>
                              <add-doctor
                                v-else
                                @added="doctorAdded"
                                :showAddButton="!isPublic"
                                v-model="model.referring_doctor_id"
                                name="referring_doctor_id"
                              />
                              <span
                                v-if="errors.has('referring_doctor_id', 'referral-form')"
                                class="invalid-feedback d-block"
                                >{{ errors.first('referring_doctor_id', 'referral-form') }}</span
                              >
                            </div>
                            <div class="col-12 col-sm-6" :class="{ 'mt-5 mt-sm-0': model.to_practice_id }">
                              <div class="">
                                <template v-if="model.to_practice_id">
                                  <label>Preferred Doctor</label>
                                  <select
                                    v-if="selectedPracticeDoctors.length > 0"
                                    @change="debounceSave"
                                    class="form-control form-control-lg form-control-xl"
                                    :disabled="!!model.sent_time"
                                    v-model="selectedDoctor"
                                    name="doctor"
                                    v-validate="'required'"
                                    data-vv-scope="referral-form"
                                    data-vv-as="Doctor"
                                  >
                                    <option value="Any (First Available)">Any (First Available)</option>
                                    <option
                                      v-for="item in selectedPracticeDoctors"
                                      :value="$helpers.displayUsername(item)"
                                      :key="item.id"
                                    >
                                      {{ $helpers.displayUsername(item) }}
                                    </option>
                                  </select>
                                  <input
                                    v-else
                                    @keyup="debounceSave"
                                    type="text"
                                    class="form-control form-control-lg form-control-xl"
                                    placeholder
                                    required
                                    v-validate
                                    v-model.trim="selectedDoctor"
                                    name="doctor"
                                    data-vv-as="doctor"
                                    :disabled="!isEditable"
                                    data-v-type="doctor"
                                  />

                                  <span v-if="errors.has('doctor', 'referral-form')" class="invalid-feedback d-block">{{
                                    errors.first('doctor', 'referral-form')
                                  }}</span>
                                </template>
                              </div>
                              <!-- <input type="hidden" v-else name="doctor" value="Any (First Available)" /> -->
                            </div>
                          </div>
                          <!-- <template v-if="
                !model.sent_time && (isIntegrationActive || activeTour === 'referralTour')
              ">
                          <div class="row no-gutters mt-5 referral-section" v-if="!isSearchPmsVisible">
                            <div class="col">
                              <div style="min-height: 50px" class="mb-3">
                                <appointment-picker @patientSelected="patientSelected" />
                              </div>
                            </div>
                          </div>
                          <div class="row mb-3" v-if="!isSearchPmsVisible">
                            <div class="col text-center">
                              <a href="javascript:void(0)" @click="isSearchPmsVisible = true">Patient not listed? Click here to search PMS</a>
                            </div>
                          </div>
                          <div v-else class="mt-5">
                            <patient-search-results ref="searchPmsInput" @close="isSearchPmsVisible = false" @patientSelected="patientSelected" />
                          </div>
                        </template> -->
                          <div class="row mt-5 referral-section bg-white" data-v-tour="patientDetails">
                            <div class="col-12 col-md-4 mb-2 mb-md-0">
                              <label>First Name</label>
                              <input
                                @keydown="debounceSave"
                                @focus="isIntegrationWidgetVisible = true"
                                type="text"
                                class="form-control form-control-lg form-control-xl"
                                placeholder
                                required
                                v-validate
                                v-model.trim="model.patient_firstname"
                                name="patient_firstname"
                                data-vv-as="patient's first name"
                                :disabled="!isEditable"
                                data-v-type="patientFirst"
                              />
                              <span class="invalid-feedback d-block">{{
                                errors.first('patient_firstname', 'referral-form')
                              }}</span>
                            </div>

                            <div class="col-12 col-md-4 mb-2 mb-md-0">
                              <label>Last Name</label>
                              <input
                                @keydown="debounceSave"
                                type="text"
                                class="form-control form-control-lg form-control-xl"
                                placeholder
                                required
                                v-validate
                                v-model.trim="model.patient_lastname"
                                name="patient_lastname"
                                data-vv-as="patient's last name"
                                :disabled="!isEditable"
                                data-v-type="patientLast"
                              />
                              <span class="invalid-feedback d-block">{{
                                errors.first('patient_lastname', 'referral-form')
                              }}</span>
                            </div>
                            <div class="col-12 col-md-4 mb-2 mb-md-0" v-if="isPatientInfoVisible">
                              <div class="">
                                <label>Phone</label>
                                <input
                                  @focus="localSave"
                                  :value="model.patient_phone"
                                  @input="phoneChange"
                                  name="patient_phone"
                                  type="text"
                                  class="form-control form-control-lg form-control-xl"
                                  placeholder
                                  required
                                  v-validate="{ required: true, regex: /\(\d{3}\)\s\d{3}-\d{4}/ }"
                                  data-vv-as="patient's phone number"
                                  :disabled="!isEditable"
                                  data-v-tour="patientPhone"
                                />
                                <span class="invalid-feedback d-block">{{
                                  errors.first('patient_phone', 'referral-form')
                                }}</span>
                              </div>
                            </div>
                          </div>

                          <template v-if="isPatientInfoVisible && isOptionalPatientDataVisible">
                            <div class="row mt-3">
                              <div class="col-md-4 col-12 mb-2 mb-md-0">
                                <div class="form-group mb-0">
                                  <label>Date of Birth</label>
                                  <datepicker
                                    v-model="model.patient_dob"
                                    @selected="debounceSave"
                                    name="patient_dob"
                                    input-class="form-control form-control-lg form-control-xl"
                                    :bootstrap-styling="true"
                                    initial-view="year"
                                    :use-utc="true"
                                    :typeable="true"
                                    :disabledDates="disabledDobDates"
                                    :disabled="!isEditable"
                                    placeholder="MM/DD/YYYY"
                                  >
                                    <span slot="afterDateInput" class="animated-placeholder input-group-lg">
                                      <div class="input-group-append">
                                        <!--!!! The inline style is needed since datepicker wraps the slot with a span that invalidates Bootstrap's selector-->
                                        <span
                                          class="input-group-text"
                                          style="
                                            padding: 0.5rem 1.25rem;
                                            border-top-left-radius: 0;
                                            border-bottom-left-radius: 0;
                                            height: calc(1.5em + 1.25rem + 2px);
                                          "
                                          >{{ patient_age }}</span
                                        >
                                      </div>
                                    </span>
                                  </datepicker>
                                </div>
                              </div>
                              <div class="col-md-4 col-12 mb-2 mb-md-0">
                                <div class="form-group mb-0">
                                  <label>Parent / Guardian Name</label>
                                  <input
                                    @keyup="debounceSave"
                                    type="text"
                                    class="form-control form-control-lg form-control-xl"
                                    placeholder
                                    v-model.trim="model.guardian_name"
                                    name="guardian_name"
                                    :disabled="!isEditable"
                                  />
                                </div>
                              </div>
                              <div class="col-md-4 col-12 mb-2 mb-md-0">
                                <div class="form-group mb-0">
                                  <label>Insurance Information</label>
                                  <select
                                    @change="debounceSave"
                                    class="form-control form-control-lg form-control-xl"
                                    v-model="model.insurance_information"
                                    name="insurance_information"
                                  >
                                    >
                                    <option :value="null">Not Provided</option>
                                    <option
                                      v-for="item in insurance_information_options"
                                      :value="item.toLowerCase().replace(/\s/g, '')"
                                      :key="item"
                                    >
                                      {{ item }}
                                    </option>
                                  </select>
                                </div>
                              </div>
                            </div>
                            <div class="row mt-3" v-if="isInsuranceVisible && isPatientInfoVisible">
                              <div class="col-lg-3 col-md-6 col-12 mb-2 mb-lg-0">
                                <div class="form-group mb-0">
                                  <label>Insurance Network</label>
                                  <input
                                    @keyup="debounceSave"
                                    type="text"
                                    class="form-control form-control-lg form-control-xl"
                                    v-model.trim="model.patient_insurance_network"
                                    name="patient_insurance_network"
                                    data-vv-as="Insurance Network"
                                    :disabled="!isEditable"
                                  />
                                  <span class="invalid-feedback d-block">{{
                                    errors.first('patient_insurance_network', 'referral-form')
                                  }}</span>
                                </div>
                              </div>
                              <div class="col-lg-3 col-md-6 col-12 mb-2 mb-lg-0">
                                <div class="form-group mb-0">
                                  <div class="row">
                                    <div class="col">
                                      <label>Subscriber Name</label>
                                      <a
                                        v-if="model.patient_insurance_subscriber !== patientFullname"
                                        class="float-right small d-within-input"
                                        href="javascript:void(0)"
                                        @click="model.patient_insurance_subscriber = patientFullname"
                                        >Use Patient Name</a
                                      >
                                    </div>
                                  </div>
                                  <input
                                    @change="debounceSave"
                                    type="text"
                                    class="form-control form-control-lg form-control-xl"
                                    v-model.trim="model.patient_insurance_subscriber"
                                    name="patient_insurance_subscriber"
                                    data-vv-as="Subscriber Name"
                                    :disabled="!isEditable"
                                  />
                                  <span class="invalid-feedback d-block">{{
                                    errors.first('patient_insurance_subscriber', 'referral-form')
                                  }}</span>
                                </div>
                              </div>
                              <div class="col-lg-3 col-md-6 col-12 mb-2 mb-md-0">
                                <div class="form-group mb-0">
                                  <div class="row">
                                    <div class="col">
                                      <label>Subscriber DOB</label>
                                      <!-- <a
                            v-if="
                              model.patient_insurance_dob !== model.patient_dob
                            "
                            class="float-right small d-within-input"
                            href="javascript:void(0)"
                            @click="
                              model.patient_insurance_dob = model.patient_dob
                            "
                            >Use Patient DOB</a
                          > -->
                                    </div>
                                  </div>

                                  <datepicker
                                    v-model="model.patient_insurance_dob"
                                    @selected="debounceSave"
                                    name="patient_insurance_dob"
                                    input-class="form-control form-control-lg form-control-xl"
                                    :bootstrap-styling="true"
                                    initial-view="year"
                                    :use-utc="true"
                                    :typeable="true"
                                    :disabledDates="disabledDobDates"
                                    data-vv-as="Subscriber DOB"
                                    :disabled="!isEditable"
                                    placeholder="MM/DD/YYYY"
                                  >
                                  </datepicker>
                                  <span class="invalid-feedback d-block">{{
                                    errors.first('patient_insurance_dob', 'referral-form')
                                  }}</span>
                                </div>
                              </div>
                              <div class="col-lg-3 col-md-6 col-12 mb-2 mb-md-0">
                                <div class="form-group mb-0">
                                  <label>SSN/Membership</label>
                                  <input
                                    @keyup="debounceSave"
                                    class="form-control form-control-lg form-control-xl"
                                    v-model="model.patient_insurance_membership"
                                    name="patient_insurance_membership"
                                    data-vv-as="SSN/Membership No."
                                  />
                                </div>
                              </div>
                            </div>
                            <div class="row" v-if="isInsuranceVisible && !activeTour && !isSecondaryInsuranceVisible">
                              <div class="col">
                                <small class="font-weight-bold"
                                  ><a href="javascript:void(0)" @click="isSecondaryInsuranceVisible = true"
                                    >Add secondary insurance</a
                                  ></small
                                >
                              </div>
                            </div>
                            <div
                              class="row mt-3"
                              v-if="isInsuranceVisible && !activeTour && isSecondaryInsuranceVisible"
                            >
                              <div class="col-12 form-group mb-0">
                                <label class>Secondary Insurance Subscriber</label>
                                <small class="font-weight-bold ml-1"
                                  ><a href="javascript:void(0)" @click="isSecondaryInsuranceVisible = false"
                                    >Remove secondary insurance</a
                                  ></small
                                >
                              </div>
                              <div class="col-lg-3 col-md-6 col-12 mb-2 mb-lg-0">
                                <div class="form-group mb-0">
                                  <label>Insurance Network</label>
                                  <input
                                    @keyup="debounceSave"
                                    type="text"
                                    class="form-control form-control-lg form-control-xl"
                                    v-model.trim="model.patient_insurance_network_secondary"
                                    name="patient_insurance_network_secondary"
                                    data-vv-as="Secondary Insurance Network"
                                    :disabled="!isEditable"
                                  />
                                  <span class="invalid-feedback d-block">{{
                                    errors.first('patient_insurance_network_secondary', 'referral-form')
                                  }}</span>
                                </div>
                              </div>
                              <div class="col-lg-3 col-md-6 col-12 mb-2 mb-lg-0">
                                <div class="form-group mb-0">
                                  <div class="row">
                                    <div class="col">
                                      <label>Subscriber Name</label>
                                      <a
                                        class="float-right small d-within-input"
                                        v-if="model.patient_insurance_subscriber_secondary !== patientFullname"
                                        href="javascript:void(0)"
                                        @click="model.patient_insurance_subscriber_secondary = patientFullname"
                                        >Use Patient Name</a
                                      >
                                    </div>
                                  </div>
                                  <input
                                    @keyup="debounceSave"
                                    type="text"
                                    class="form-control form-control-lg form-control-xl"
                                    v-model.trim="model.patient_insurance_subscriber_secondary"
                                    name="patient_insurance_subscriber_secondary"
                                    data-vv-as="Secondary Subscriber Name"
                                    :disabled="!isEditable"
                                  />
                                  <span class="invalid-feedback d-block">{{
                                    errors.first('patient_insurance_subscriber_secondary', 'referral-form')
                                  }}</span>
                                </div>
                              </div>
                              <div class="col-lg-3 col-md-6 mb-2 mb-md-0">
                                <div class="form-group mb-0">
                                  <div class="row">
                                    <div class="col">
                                      <label>Subscriber DOB</label>
                                      <!-- <a
                            v-if="
                              model.patient_insurance_dob_secondary !==
                              model.patient_dob
                            "
                            class="float-right small d-within-input"
                            href="javascript:void(0)"
                            @click="
                              model.patient_insurance_dob_secondary =
                                model.patient_dob
                            "
                            >Use Patient DOB</a
                          > -->
                                    </div>
                                  </div>

                                  <datepicker
                                    v-model="model.patient_insurance_dob_secondary"
                                    @selected="debounceSave"
                                    name="patient_insurance_dob_secondary"
                                    input-class="form-control form-control-lg form-control-xl"
                                    :bootstrap-styling="true"
                                    initial-view="year"
                                    :use-utc="true"
                                    :typeable="true"
                                    :disabledDates="disabledDobDates"
                                    data-vv-as="Secondary Subscriber DOB"
                                    :disabled="!isEditable"
                                    placeholder="MM/DD/YYYY"
                                  ></datepicker>
                                  <span class="invalid-feedback d-block">{{
                                    errors.first('patient_insurance_dob_secondary', 'referral-form')
                                  }}</span>
                                </div>
                              </div>
                              <div class="col-lg-3 col-md-6 col-12 mb-2 mb-md-0">
                                <div class="form-group mb-0">
                                  <label>SSN/Membership</label>
                                  <input
                                    class="form-control form-control-lg form-control-xl"
                                    @keyup="debounceSave"
                                    v-model="model.patient_insurance_membership_secondary"
                                    name="patient_insurance_membership_secondary"
                                    data-vv-as="Secondary SSN/Membership No."
                                  />
                                </div>
                              </div>
                            </div>
                          </template>
                          <div class="row mt-2">
                            <div class="col">
                              <a
                                class="font-weight-bolder font-size-1"
                                href="javascript:void(0)"
                                @click="
                                  withPremium(
                                    () => (isOptionalPatientDataVisible = !isOptionalPatientDataVisible),
                                    isPatientInfoVisible
                                  )
                                "
                              >
                                <font-awesome-icon
                                  class="mr-2"
                                  :icon="['far', !isOptionalPatientDataVisible ? 'plus' : 'minus']"
                                />Additional information
                              </a>
                            </div>
                          </div>
                          <div class="row mt-5 referral-section reasons-section">
                            <div class="col" data-v-tour="referralReasons">
                              <h6 class="">
                                Reason for Referral
                                <template v-if="model.to_practice_id && referralTypes.length === 1"
                                  >({{ referralTypes.join(', ') }})</template
                                >
                                <span
                                  class="invalid-feedback d-inline font-weight-normal"
                                  v-show="errors.has('reason', 'referral-form')"
                                  >{{ errors.first('reason', 'referral-form') }}</span
                                >
                              </h6>
                              <div v-if="!model.to_practice_id">
                                <i class="text-hint font-weight-normal"
                                  >Common reasons will become available once you select a practice</i
                                >
                              </div>
                              <div v-for="pair in exisitingReasonsTags" :key="pair[0] + 'reasons'">
                                <small class="text-muted font-weight-bold d-block mb-1">{{ pair[0] }}</small>
                                <a
                                  v-for="reason in pair[1]"
                                  :key="reason.key"
                                  class="btn btn-light btn-sm px-3 text-center font-weight-bolder py-2 mr-2 mb-2"
                                  :class="{ active: reason.active }"
                                  @click.stop="toggleReason(reason.key)"
                                  >{{ reason.value }}</a
                                >
                              </div>

                              <h6 class="mt-5">
                                Comment
                                <span
                                  class="invalid-feedback d-inline font-weight-normal"
                                  v-show="errors.has('reason', 'referral-form')"
                                  >{{ errors.first('reason', 'referral-form') }}</span
                                >
                              </h6>
                              <div v-if="model.sent_time">
                                {{ model.comments }}
                              </div>
                              <textarea
                                @keyup="debounceSave"
                                v-model="model.comments"
                                name="comments"
                                rows="8"
                                class="form-control mb-0 mb-md-3"
                                data-vv-as="reason"
                                data-vv-scope="referral-form"
                              />
                            </div>
                            <div class="col-12 col-md-6 order-2 order-md-1 mt-5 mt-md-0">
                              <div class="row">
                                <!-- <div class="col-12 col-sm-7 order-2 order-sm-1 text-center"> -->
                                <div class="col-12">
                                  <div class="" :class="toothPickerTourClass">
                                    <div class="row">
                                      <div class="col">
                                        <h6>Teeth</h6>
                                      </div>
                                      <div v-if="errors.has('teeth', 'referral-form')" class="col text-right">
                                        <span class="invalid-feedback d-inline">{{
                                          errors.first('teeth', 'referral-form')
                                        }}</span>
                                      </div>
                                    </div>
                                    <div class="row" style="margin-top: -25px">
                                      <div class="col text-center">
                                        <a
                                          v-if="!model.sent_time"
                                          href="javascript:void(0);"
                                          style="margin-top: 0; margin-bottom: -40px; z-index: 99999"
                                          class="btn btn-light btn-xs px-3 text-center font-weight-bolder py-2"
                                          :class="{
                                            active:
                                              model.teeth &&
                                              ['LL', 'LR', 'UL', 'UR'].every((t) => model.teeth.includes(t)),
                                          }"
                                          @click.stop.prevent="setFullMouth"
                                          >Select full mouth</a
                                        >
                                      </div>
                                    </div>
                                    <ToothPicker
                                      @input="debounceSave"
                                      v-model="model.teeth"
                                      class=""
                                      :key="'Tooth-picker-' + model.id"
                                      :disabled="!!model.sent_time"
                                      :class="{
                                        'z-index-for-tour': isTourToothPicker,
                                        'border rounded border-danger': errors.has('teeth', 'referral-form'),
                                      }"
                                      data-vv-as="teeth"
                                      v-validate="'required'"
                                      data-vv-scope="referral-form"
                                    />
                                  </div>
                                </div>
                              </div>
                              <div
                                v-if="tooth_list.length > 0"
                                class="d-block tooth-number-only"
                                v-html="$helpers.formatToothList(tooth_list)"
                              ></div>
                            </div>
                          </div>
                          <div class="row form-group referral-section">
                            <div class="col-12 mt-5 mt-sm-0">
                              <h6>Attached files</h6>

                              <!-- <InternalFiles :id="model.patient_internal_id_sender" :referralId="model.id" class="mt-3 pt-3" /> -->
                              <!-- <span if v-if="!model.attachments || !model.attachments.length" class="text-muted font-weight-normal">No attachments have been uploaded</span> -->

                              <attachments ref="attachments" :referralId="model.id" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
                <div
                  class="bottom-bar flex-column"
                  v-if="
                    showAppointmentPicker && !model.sent_time && (isIntegrationActive || activeTour === 'referralTour')
                  "
                  :class="{ searching: isSearchPmsVisible }"
                >
                  <span class="badge badge-lg badge-secondary" style="position: absolute; top: -0.5rem"
                    >Refera premium</span
                  >
                  <div class="d-flex justify-content-between mb-3">
                    <h5 class="mb-0">Your appointments today</h5>
                    <a
                      href="javascript:void(0)"
                      class="btn btn-outline-primary font-weight-bold"
                      @click="withPremium(() => (isSearchPmsVisible = !isSearchPmsVisible))"
                    >
                      <template v-if="!isSearchPmsVisible">
                        <font-awesome-icon :icon="['far', 'search']" class="mr-1" /> Search your patients </template
                      ><template v-else>
                        <font-awesome-icon :icon="['far', 'calendar']" class="mr-1" /> Your appointments
                      </template>
                    </a>
                  </div>
                  <div style="min-height: 50px" class="" v-if="!isSearchPmsVisible">
                    <AppointmentPicker @patientSelected="patientSelected" />
                  </div>
                  <div v-else class="">
                    <PatientSearchResults
                      ref="searchPmsInput"
                      @close="isSearchPmsVisible = false"
                      @patientSelected="patientSelected"
                    />
                  </div>
                  <small class="text-muted"
                    >Last data sync
                    {{
                      user.practice.integration_last_sync
                        ? moment(user.practice.integration_last_sync).fromNow()
                        : 'unavailable'
                    }}</small
                  >
                </div>
              </div>
              <ReferralRightBar
                v-if="showSidebar"
                :referralId="referral.id"
                :isExpandable="false"
                :isIntegrationWidgetVisible="isIntegrationWidgetVisible"
              />
            </div>
            <!-- <referral-example-guide v-if="isTestReferral" /> -->
          </template>
        </div>
        <modal v-if="!isNew && model.id" :show="showSendModal" @close="$emit('closeSendModal')" class="alt-header">
          <div class="modal-header row no-gutters">
            <div class="col-auto">
              <h3 class="m-0">Please confirm the referral</h3>
            </div>
            <div class="col text-right">
              <a @click="$emit('closeSendModal')" title="Close" href="javascript:void(0)">
                <font-awesome-icon :icon="['far', 'times']" size="2x" />
              </a>
            </div>
          </div>
          <div class="modal-body row h-100 overflow-hidden">
            <div class="row h-100 no-gutters">
              <div class="col-9 h-100 overflow-auto">
                <div class="d-block mx-auto">
                  <div class="d-flex h-100 w-100 py-3 my-3">
                    <PrintReferral
                      ref="viewReferral"
                      class="preview"
                      style="width: 90%"
                      :referralId="model.id"
                      :showInsurance="true"
                      :isAutoPrint="false"
                      :isImportant="model.is_important"
                      :isUploadEnabled="false"
                    />
                  </div>
                </div>
                <!-- <iframe ref="printpreview" :key="model.id + model.updated_at" :src="
            showSendModal
              ? `#/referral/print/${model.id}/?autoPrint=false&cb=${model.client_version}&isImportant=${model.is_important}`
              : ''
          " width="99%" class="p-0 flex-fill" style="border: 0; margin: 0 auto;height: 100%;width: 100%;" data-v-tour="previewReferral"></iframe>
               -->
              </div>
              <div class="col-3 p-2 d-flex flex-column">
                <div class="border rounded p-3 mt-auto">
                  <div class="form-check text-right pl-0 d-flex">
                    <div
                      class="custom-control custom-switch custom-switch-md justify-content-center align-self-center"
                      style="cursor: pointer"
                    >
                      <input
                        v-model="model.is_important"
                        type="checkbox"
                        class="custom-control-input"
                        name="is_important"
                        id="Switch-important-patient"
                        @input="saveIfPending"
                      />
                      <label
                        class="custom-control-label"
                        for="Switch-important-patient"
                        style="cursor: pointer; font-weight: bold"
                        >Mark important</label
                      >
                    </div>
                  </div>
                  <small class="d-block mt-1"
                    >Request that the receiver contacts the patient to schedule an appointment.</small
                  >
                </div>
                <div class="border rounded p-3 mt-3">
                  <!-- <div class="badge badge-secondary" style="position:absolute; margin-top:-25px; right:25px">Premium</div> -->
                  <div class="form-check text-right pl-0 d-flex">
                    <div
                      class="custom-control custom-switch custom-switch-md justify-content-center align-self-center"
                      style="cursor: pointer"
                    >
                      <input
                        v-model="model.is_patient_opted_in"
                        type="checkbox"
                        class="custom-control-input"
                        name="is_patient_opted_in"
                        id="Switch-text-patient"
                        @input="saveIfPending"
                      />
                      <label
                        class="custom-control-label"
                        for="Switch-text-patient"
                        style="cursor: pointer; font-weight: bold"
                        >Text patient a copy</label
                      >
                    </div>
                  </div>
                  <small class="d-block mt-1"
                    >Send a copy of the referral via text to the patient.
                    <!-- <a href="javascript:void(0)">See example</a> -->
                  </small>
                </div>
              </div>
            </div>
          </div>
          <div class="row modal-footer">
            <div class="col p-0">
              <div class="row no-gutters">
                <div class="col-auto text-left">
                  <!-- <button class="btn btn-light" @click="$refs.printpreview.contentWindow.print()" data-v-tour="printReferral">
                    <font-awesome-icon :icon="['far', 'print']" class="mr-md-2" />
                    <span class="d-none d-md-inline">Print</span>
                  </button> -->
                </div>
                <div class="col text-right">
                  <a
                    href="javascript:void(0)"
                    class="btn btn-link mr-2"
                    @click.stop="$emit('closeSendModal')"
                    :disabled="isSending"
                  >
                    Edit Referral
                  </a>
                  <button
                    class="btn btn-primary btn-lg"
                    style="padding: 0.85rem 1.75rem"
                    @click.stop="send"
                    :disabled="isSending || latestSavedCv < latestPendingCv"
                    data-v-tour="confirmReferral"
                  >
                    <font-awesome-icon icon="spinner-third" v-if="isSending" spin />
                    <span v-else>Confirm &amp; Send</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </modal>
      </Dropzone>
    </div>
  </div>
</template>
<script>
import Empty from '@/components/shared/Empty.vue'
import { ReferralApi } from '@/services'
import Modal from '@/components/Modal'
import Datepicker from 'vuejs-datepicker'
import moment from 'moment'
import ToothPicker from '@/components/ToothPicker'
import AppointmentPicker from '@/components/referrals/integration/AppointmentPicker'
import PatientSearchResults from '@/components/referrals/integration/PatientSearchResults'
import { mapGetters, mapState } from 'vuex'
import ReferralRightBar from '@/components/referrals/rightbar/ReferralRightBar.vue'
import Attachments from '@/components/referrals/Attachments.vue'
import Dropzone from '@/components/shared/Dropzone.vue'
import PrintReferral from '@/views/referrals/PrintReferral'
import AddDoctor from '@/components/AddDoctor.vue'
import * as Sentry from '@sentry/vue'
import ReferralLoader from '@/components/referrals/inbox/ReferralLoader.vue'
import VeeValidate from 'vee-validate'
import ReferralExampleGuide from '../../components/referrals/ReferralExampleGuide.vue'
import PracticeAutoComplete from '../../components/add-practice/PracticeAutoComplete.vue'
import { PracticeApi } from '../../services'
import equal from 'fast-deep-equal'
import ReferralNotFound from './ReferralNotFound.vue'
export default {
  components: {
    Datepicker,
    ToothPicker,
    Modal,
    AppointmentPicker,
    PatientSearchResults,
    ReferralRightBar,
    Attachments,
    Dropzone,
    PrintReferral,
    AddDoctor,
    ReferralLoader,
    Empty,
    ReferralExampleGuide,
    PracticeAutoComplete,
    ReferralNotFound,
  },
  props: {
    showSendModal: { default: false },
    showHistory: { default: false },
    showSidebar: { default: true },
    showAppointmentPicker: { default: true },
    allowPracticeChange: { default: true },
    redirectOnCreate: { default: '/referral/' },
  },
  created() {},
  async mounted() {
    VeeValidate.configure({ events: '' })
    if (this.$route.query.data) {
      this.populateFromUrlData()
    }
    const toPracticeId = this.$route.query.to || this.$route.params.to
    if (toPracticeId !== '0') {
      this.model.to_practice_id = toPracticeId
      if (this.$route.params.to) {
        try {
          this.model.to_practice = this.public_to_practice = await PracticeApi.get(this.$route.params.to, {
            anonymous: true,
          })
          this.model.to_practice_id = this.model.to_practice.id
        } catch (err) {
          this.$exception(err)
          this.$helpers.error('Failed to load practice data')
        }
      }
    }
    if (this.$route.params?.id == 'example-referral') {
      if (!this.activeTour) {
        this.$router.replace('/')
        return
      }
      this.$store.commit('tour/setCurrentMockReferral', this.$store.getters['tour/mockReferral'](this.$store))
      this.$store.dispatch('referrals/save', this.currentMockReferral)
    }
    if (this.isCreateReferral) {
      try {
        this.model.is_patient_opted_in = true || this.isPremium
        if (!this.isPremium && this.user?.practice?.referrals_remaining == 0) {
          this.$dialog.alert('You have reached your quota for sending referrals.')
          this.$router.replace('/manage/billing')
          return
        }
        const r = await this.$store.dispatch('referrals/save', this.model)
        try {
          this.$track('$referralCreate')
        } catch {}
        this.$router.replace(this.redirectOnCreate + r.id)
      } catch (e) {
        this.$exception(e)
        console.error(e)
        this.$helpers.error('An unexpected error occured. Please refresh and try again.')
      }
      return
    }
    if (!this.isPracticesLoaded && !this.isPracticesLoading) {
      this.$store.dispatch('practices/load')
    }
    if (!this.isReferralsLoaded && !this.isNew) await this.$store.dispatch('referrals/load')

    if (this.$route.params.id) {
      if (!this.referral?.id) {
        this.$exception(
          new Error(
            'referral object is empty when mounting: ' +
              this.$route.params.id +
              ' ref loaded: ' +
              this.isReferralsLoaded +
              ' isNew: ' +
              this.isNew
          )
        )
      }
      this.model = Object.assign({}, this.referral)
    }

    const appointmentsLoading = this.$store.dispatch('appointments/load')

    if (!this.model.referring_doctor_id) {
      this.model.referring_doctor_id = this.practiceDoctors?.[0]?.id
    }
    this.isAddDoctor = this.isPublic
    this.isLoading = false
    if (this.$route.params.id == 'example-referral') {
      await appointmentsLoading
      this.$store.dispatch('tour/next')
    }
  },
  data() {
    return {
      isLoading: true,
      isSubmitted: false,
      isSubmitting: false,
      isSending: false,
      isSaving: false,
      isHistoryVisible: this.showHistory,
      isCloseReferralModalVisible: false,
      isSelectedTeethConfirmed: true,
      isOptionalPatientDataVisible: false,
      saveTimeout: null,
      model: {
        referring_doctor_id: null,
        to_practice: null,
        to_practice_id: null,
        type: null,
        doctor: 'Any (First Available)',
        patient_insurance_subscriber: '',
        patient_insurance_subscriber_secondary: '',
        patient_insurance_dob_secondary: null,
        patient_insurance_dob: null,
        reasons: [],
        insurance_information: '',
        teeth: [],
        is_patient_opted_in: true,
        is_important: false,
      },
      insurance_information_options: ['Provided Below', 'Call Office', 'Call Patient', 'No Insurance'],
      preferred_contact_methods: ['Any', 'Email', 'Phone'],
      history: [],
      disabledDobDates: {
        from: new Date(),
      },
      note: '',
      isSearchPmsVisible: false,
      clientVersion: null,
      isAddDoctor: false,
      isIntegrationWidgetVisible: false,
      isSecondaryInsuranceVisible: false,
      latestPendingCv: null,
      latestSavedCv: null,
      isChangePracticeShown: false,
      public_to_practice: null,
    }
  },
  computed: {
    ...mapGetters('settings', ['PracticeTypes', 'WithReasons', 'FlatReasons', 'DemoId']),
    ...mapGetters('practices', {
      practices: 'assignable', //todo:should be based off of referral practice id,
    }),
    ...mapState('referrals', {
      referralLoadError: 'error',
      isReferralsLoading: 'isLoading',
      isReferralsLoaded: 'isLoaded',
    }),
    // ...mapGetters('users', ['doctors']),
    ...mapState('practices', {
      doctors: 'doctors',
      isPracticesLoaded: 'isLoaded',
      isPracticesLoading: 'isLoading',
    }),
    ...mapState('appointments', {
      isLoadingAppointments: 'isLoading',
      appintments: 'appointments',
    }),
    ...mapGetters('auth', ['isIntegrationActive', 'isPublicLoggedIn', 'user', 'isTokenAvailable']),
    ...mapState('tour', ['activeTour', 'currentMockReferral']),
    ...mapGetters('tour', ['currentTarget']),
    isPublic() {
      return !this.user?.practice || this.isPublicLoggedIn
    },
    isAllowPracticeChange() {
      return this.allowPracticeChange
    },
    isTourToothPicker() {
      return this.currentTarget === '[data-v-tour="selectTooth"]'
    },
    toothPickerTourClass() {
      return this.isTourToothPicker ? 'v-tour__target--highlighted bg-white' : ''
    },
    isLoaded() {
      return !!(
        this.isReferralsLoaded &&
        !this.isLoading &&
        (!this.$route.params.id || (this.referral && this.referral.id && this.model?.id))
      )
    },
    referral() {
      if (this.$route.params.id == 'example-referral') {
        return this.$store.getters['tour/mockReferral'](this.$store)
      }
      const id = this.$route.params.id
      return id ? this.$store.getters['referrals/get'](id) : {}
    },
    isNotFound() {
      return (
        (this.isReferralsLoaded &&
          this.$route.params.id > 0 &&
          (!this.referral || !Object.keys(this.referral).length)) ||
        !this.referral
      )
    },
    isPremium() {
      return this.$store.getters['billing/isPremium']
    },
    isPatientInfoVisible() {
      return this.isNew || this.isPremium || (this.model && !this.model.is_incoming)
    },
    isEditable() {
      //todo: for now let patient information be edited but we may decide to make this readonly if archived (closed or cancelled)
      return (
        this.isNew ||
        (!this.model.cancelled_time &&
          !this.model.completed_time &&
          (this.isPremium || (this.referral && !this.referral.is_incoming)))
      )
    },
    isFormDirty() {
      if (!this.isNew) return JSON.stringify(this.model) !== JSON.stringify(this.referral)
      //todo: this will only scope to validated fields, need to extend to check non required fields. Maybe even unadded notes, failed uploads too?
      const fields = this.fields['$referral-form']
      return !fields ? false : Object.keys(fields).some((key) => fields[key].dirty)
    },
    isOwnedByCurrentPractice: function () {
      return this.isNew || (this.model.practice && !this.model.is_incoming)
    },
    patient_age: function () {
      let age = moment().diff(this.model.patient_dob, 'months'),
        diff = age < 24 ? { y: 0, m: age || 0 } : { y: (age && Math.floor(age / 12)) || 0, m: (age || 0) % 12 }
      return `${diff.y}y ${diff.m}m` // ignore < 1 mo old and just display 0.
    },
    tooth_list: function () {
      if (!this.model || !this.model.teeth || !this.model.teeth.length) return []
      // provide natural sort for numbers, probably not the most desired solution
      // Deciduous teeth (A,B,C etc) will be ordered within Quandrant (LL, UR etc)
      const collator = new Intl.Collator(undefined, {
        numeric: true,
        sensitivity: 'base',
      })
      let teeth = [].slice.call(this.model.teeth)
      teeth.sort(collator.compare)
      return teeth
    },
    history_ordered: function () {
      //safe to assume the data is ordered date asc so we just reverse for newest first.
      return this.model.history
    },
    isNew: function () {
      return !this.$route.params.id || this.$route.params.id === 'create'
    },
    practiceDoctors: function () {
      return this.user.practice?.doctors || []
    },
    selectedPracticeDoctors: function () {
      if (this.model.to_practice?.doctors?.length || this.public_to_practice?.doctors?.length)
        return this.public_to_practice?.doctors || this.model.to_practice?.doctors
      console.warn(
        'Selected practice has no doctors, using internal state',
        this.doctors.length,
        this.doctors,
        this.model.to_practice
      )
      return this.doctors.filter((u) => u.practice == this.model.to_practice_id)
    },
    referralType() {
      if (this.model && this.model.to_practice) return this.PracticeTypes[this.model.to_practice.specialty]
      if (this.isLoading || !this.practices || !this.model.to_practice_id) {
        return
      }
      const currentPractice = this.user.practice
      let toPractice =
        this.model.to_practice_id == currentPractice.id
          ? currentPractice
          : this.practices.find((p) => p.id == this.model.to_practice_id)

      if (!toPractice) return

      return this.PracticeTypes[toPractice.specialty]
    },
    referralTypes() {
      if (this.model && this.model.to_practice)
        return this.model.to_practice.specialties.map((s) => this.PracticeTypes[s])
      if (this.isLoading || !this.practices || !this.model.to_practice_id) {
        return
      }
      const currentPractice = this.user.practice
      let toPractice =
        this.model.to_practice_id == currentPractice.id
          ? currentPractice
          : this.practices.find((p) => p.id == this.model.to_practice_id)

      if (!toPractice) return

      return toPractice.specialties.map((s) => this.PracticeTypes[s])
    },
    exisitingReasonsTags() {
      return (
        this.referralTypes &&
        this.referralTypes
          .map((s) => {
            const reasons = this.WithReasons[s]
            const withActive = Object.keys(reasons)
              .map((key) => ({
                key,
                value: reasons[key],
                active: this.model.reasons.includes(key),
              }))
              .sort((a, b) => a.value.localeCompare(b.value))

            return [s, withActive]
          })
          .filter((s) => s[1]?.length)
      )
    },
    modelReasons: {
      get: function () {
        if (!this.model.reasons || !this.model.reasons.length) return
        const reasons = this.FlatReasons || {}
        //todo: known bug - if there are exisiting reasons and the practice is changed, the type can be changed which will treat exisiting reasons as custom.
        return (
          reasons &&
          this.model.reasons.map((key) => ({
            key,
            value: key in reasons ? reasons[key] : key,
          }))
        )
      },
      set: function (reasons) {
        if (reasons.length === this.model.reasons.length) return //prevents loop
        this.model.reasons = reasons.map((kv) => kv.key || kv.value)
      },
    },
    patientFullname() {
      return [this.model.patient_firstname, this.model.patient_middlename, this.model.patient_lastname]
        .filter((s) => s)
        .join(' ')
    },
    isInsuranceVisible() {
      return this.model.insurance_information === 'providedbelow'
    },
    selectedDoctor: {
      get() {
        return this.selectedPracticeDoctors.length === -1 ? 'Any (First Available)' : this.model.doctor
      },
      set(doctor) {
        this.model.doctor = doctor
      },
    },
    from: function () {
      return this.model.practice
    },
    practice: function () {
      return this.model.to_practice
    },
    showInsurance() {
      return true
    },
    attachmentsWithAbsUrl() {
      return this.model?.attachments?.map((a) => ({
        ...a,
        absUrl: this.$helpers.cdnUrl(a.url),
      }))
    },
    isSchedulable() {
      return this.$helpers.isSchedulable(this.referral) && !this.referral.scheduled_time
    },
    isCreateReferral() {
      return !this.$route.params.id || this.$route.params.id === 'create'
    },
    isTestReferral() {
      return this.practice?.id == this.DemoId
    },
  },
  watch: {
    referral(newReferral, oldReferral) {
      // console.info(newReferral?.id, oldReferral?.id)
      // console.info({ newReferral, oldReferral })
      // if (!this.model.id && newReferral?.id) {
      //   console.warn('Model was not set, updating model with new data')
      //   this.model = Object.assign({}, newReferral)
      // }
      // const isEqual2 = equal({ ...newObj, updated_at: null }, { ...oldObj, updated_at: null });
      // console.log({ isEqual2, newCv: newReferral?.client_version, oldCv: oldReferral.client_version, cv: this.clientVersion, newReferral, oldReferral })
      if (this.$route.params.id > 0 && oldReferral) {
        const userId = this.user.id
        if (
          userId &&
          newReferral &&
          !(newReferral.updated_by.id == userId || newReferral.history?.slice(-1)[0]?.created_by?.id == userId)
        ) {
          //todo: we should really be looking at client changes and comparing them with remote, if any other possible
          // client changes are made then they are made in anyother session (could be same user account)
          // console.log(newReferral.updated_by.id, userId, newReferral.history?.slice(-1)[0])
          // console.log(JSON.stringify(oldReferral), JSON.stringify(newReferral))
          // console.log({
          //   isEqual,
          //   newCv: newReferral?.client_version,
          //   oldCv: oldReferral.client_version,
          //   cv: this.clientVersion,
          //   newReferral,
          //   oldReferral,
          // })
          if (newReferral?.client_version > oldReferral.client_version) {
            const isEqual = equal(
              { ...newReferral, updated_at: null, is_saving: null, client_version: null },
              { ...this.model, updated_at: null, is_saving: null, client_version: null }
            )
            if (!isEqual) {
              this.$helpers.info(
                'This referral has been updated by someone else. You are now seeing the latest version.'
              )
              // console.log(JSON.stringify({ ...newReferral, updated_at: null, is_saving: null, client_version: null }))
              // console.log(JSON.stringify({ ...oldReferral, updated_at: null, is_saving: null, client_version: null }))
            }
          }
        }
        if (newReferral?.client_version > this.clientVersion) {
          // this.clientVersion = newReferral.client_version
          this.model = Object.assign({}, newReferral)
        }
      } else {
        console.warn('Not updating model with new referral', oldReferral)
      }
    },
    '$route.query.data': function () {
      this.populateFromUrlData()
    },
    '$route.params.id': async function () {
      this.model = Object.assign({}, this.referral)
    },
    currentMockReferral(currentMockReferral, old) {
      this.model = Object.assign(this.model, currentMockReferral)
    },
    isPublic(curr, prev) {
      this.isAddDoctor = curr
    },
    practiceDoctors(curr, prev) {
      if (curr?.length === 1) this.model.referring_doctor_id = this.practiceDoctors?.[0]?.id
    },
  },
  methods: {
    toggleReason(reasonKey) {
      if (this.$route.params.id === 'example-referral') this.$store.dispatch('tour/next')
      if (!this.model.reasons) throw 'Reasons array is not initialized'
      const index = this.model.reasons.indexOf(reasonKey)
      if (index === -1) {
        this.model.reasons.push(reasonKey)
        this.addedReason(reasonKey)
      } else {
        this.model.reasons.splice(index, 1)
        this.removedReason(reasonKey)
      }
      this.debounceSave()
    },

    async send() {
      if (this.latestSavedCv < this.latestPendingCv) {
        //technically this shouldn't matter since the payload of the latest will have the latest
        //though it is best to wait in case any errors occur -
        //could await a save handler here and not disable the button or clear debounce queue
        console.warn('Cannot send referral, awaiting pending changes')
        return
      }
      const _this = this
      this.isSelectedTeethConfirmed = true
      const valid = await this.validate()
      if (!valid) {
        this.$emit('closeSendModal')
        return
      }
      // _this.$validator
      //   .validate('isSelectedTeethConfirmed')
      //   .then(async (isTeethConfirmed) => {
      //if (!isTeethConfirmed) return
      _this.isSending = true
      _this.model.sent_time = moment.utc()
      _this
        .submit()
        .then((data) => {
          _this.$store.dispatch('tour/next')
          if (!data) return
          //since sent_time is set, the editor instance is not mounted
          _this.$emit('closeSendModal')
          _this.$store.dispatch('referrals/setIsSuccessModalShown', true)
          _this.$store.dispatch('referrals/filter', 'All')
          _this.$track('referralSent')
        })
        .catch((e) => console.error(e))
        .finally(() => (_this.isSending = false))
      // })
    },
    validate() {
      const _this = this
      return this.$validator.validate('referral-form.*').then(function (valid) {
        if (valid) return true
        return false
      })
    },

    save() {
      let isNew = this.isNew && !this.model?.id
      const router = this.$router
      this.isSaving = true
      this.$emit('isSaving', true)
      const _this = this
      return this.submit().then(function (response) {
        _this.isSaving = false
        _this.$emit('isSaving', false)
        _this.latestSavedCv = response.client_version
        //todo: last save date
        if (isNew && response && response.id) router.replace(_this.redirectOnCreate + response.id)
      })
    },
    saveIfPending() {
      //this is for the modal toggles - favour localSave if there are no pending
      if (this.latestSavedCv >= this.latestPendingCv)
        //could use isSaving but it wouldnt handle concurrency
        this.localSave()
      else this.debounceSave()
    },
    localSave() {
      this.model.client_version = Date.now()
      // this.clientVersion = this.model.client_version
      if (this.model.referring_doctor_id !== this.model.referring_doctor?.id)
        this.model.referring_doctor = {
          ...this.practiceDoctors.find((s) => s.id == this.model.referring_doctor_id),
        }
      if (!this.model.id) this.save()
      else this.$store.commit('referrals/saveReferral', this.model)
    },
    debounceSave() {
      //todo: patch referral, track queue of changes and handle errors
      this.localSave()
      this.latestPendingCv = this.model.client_version
      if (this.saveTimeout) clearTimeout(this.saveTimeout)
      this.saveTimeout = setTimeout(this.save, 1250)
    },
    async submit() {
      const _this = this
      _this.isSubmitting = true

      if (!this.user?.practice) {
        await this.$store.dispatch('auth/loginPublic')
      }
      // return Promise.resolve(_this)
      return new Promise((resolve, reject) =>
        _this.$store
          .dispatch('referrals/save', _this.model)
          //todo: dispatch and mutate state via store.
          //return ReferralApi.save(_this.model)
          .then((s) => {
            _this.isSubmitted = true
            resolve(s)
          })
          .catch(_this.onError)
          .finally(() => {
            _this.isSubmitting = false
          })
      )
    },
    submitNote() {
      if (!this.model || !this.model.id) return
      ReferralApi.saveRelated(this.model.id, 'history', {
        details: this.note,
        referral_id: this.model.id,
      }).then(this.onNoteSubmitted)
    },
    onNoteSubmitted(response) {
      this.note = ''
      //this.model.history.push(response);
    },
    onError(data) {
      // this.isOptionalPatientDataVisible = true
      this.$nextTick(() => {
        const errors = (data && data.errors) || data || {}
        if (typeof errors === 'string') {
          console.error(errors)
          this.$exception(data)
          return
        }
        const eKeys = Object.keys(errors)
        console.log('Errors!', errors)
        for (const key of eKeys) {
          if (key && errors[key][0]) {
            if (key == 'detail') {
              this.$helpers.error('Failed to save: ' + errors[key])
              //todo: if erros[key] == 'Not found',
              //better pubnub signal deleted referral and remove from state
            } else this.setFieldError(key, errors[key][0])
          } else {
            console.error('Invalid key in errors', errors, key)
          }
        }
        if (!eKeys.length) {
          this.$exception(data)
        }
      })
    },
    setFieldError(field, msg) {
      if (!field) {
        console.error(`Field ${_field} within ${scope} could not be found. ${msg}`)
        return
      }
      const scope = this.$options.scope || 'referral-form'
      const _field = this.$validator.fields.find({
        name: field,
        scope: scope,
      })

      if (!_field) throw new Error(`Field ${_field} within ${scope} could not be found`)

      this.$validator.errors.add({
        id: _field.id,
        field,
        msg,
        scope: scope,
      })
      this.$nextTick(() => {
        _field.setFlags({ invalid: true, valid: false, validated: true })
      })
    },
    getHistoryItemClass(history) {
      if (history.details === 'Referral Cancelled') return 'danger'
      if (['Completed', 'Created', 'Sent', 'Scheduled'].some((s) => `Referral ${s}` === history.details))
        return 'primary'
      return history.type === 'SYSTEM' ? 'info' : 'secondary'
    },
    populateFromUrlData() {
      let data = {}
      if (this.$route.query.data) data = JSON.parse(atob(this.$route.query.data))
      this.model = Object.assign({}, this.model, data)
    },
    patientSelected(patient) {
      const map = {
        patient_internal_id_sender: !patient ? '' : patient.id,
        patient_firstname: !patient ? '' : patient.firstname,
        patient_middlename: !patient ? '' : patient.middlename,
        patient_lastname: !patient ? '' : patient.lastname,
        patient_phone: !patient ? '' : this.$options.filters.phone(patient.phone),
        patient_email: !patient ? '' : patient.email,
        patient_dob: !patient ? undefined : patient.birthdate,
        guardian_name: !patient ? '' : patient.guardian,
        patient_insurance_network: !patient ? '' : patient.primary_insurance_network,
        patient_insurance_subscriber: !patient ? '' : patient.primary_insurance_subscriber,
        patient_insurance_membership: !patient ? '' : patient.primary_insurance_membership,
        patient_insurance_network_secondary: !patient ? '' : patient.secondary_insurance,
        insurance_information: (patient && patient.primary_insurance_network && 'providedbelow') || 'noinsurance',
        preferred_contact_method: 'any', // !patient          ? ''          : patient.phone && patient.email          ? 'any'          : patient.phone          ? 'phone'          : patient.email          ? 'email'          : '',
      }
      Object.keys(map).map((k) => {
        this.$set(this.model, k, map[k] || null)
        // this.$nextTick(() => {
        //   const scope = this.$options.scope || 'referral-form'
        //   const _field = this.$validator.fields.find({
        //     name: k,
        //     scope: scope,
        //   })
        //   // debugger
        //   // if (_field)
        //   //   _field.setFlags({ touched: true, dirty: true, validated: false })
        // })
      })
      this.isOptionalPatientDataVisible = !!patient
      this.save()
      // this.$validator.validate('referral-form.*')
    },
    addedReason(key) {
      if (this.model.teeth && this.model.teeth.length) return
      if (key === 'new_patient_evaluation') {
        this.model.teeth = ['LL', 'LR', 'UL', 'UR']
      }
      if (key === 'third_molar_extraction') {
        this.model.teeth = ['1', '16', '17', '32']
      }
    },
    removedReason(key) {
      const teeth = this.model.teeth
      if (teeth && teeth.length) {
        if (key === 'new_patient_evaluation' && ['LL', 'LR', 'UL', 'UR'].every((t) => teeth.includes(t))) {
          this.model.teeth = teeth.filter((t) => !['LL', 'LR', 'UL', 'UR'].includes(t))
        }
        if (key === 'third_molar_extraction' && ['1', '16', '17', '32'].every((t) => teeth.includes(t))) {
          this.model.teeth = teeth.filter((t) => !['1', '16', '17', '32'].includes(t))
        }
      }
    },
    setFullMouth() {
      this.model.teeth = ['LL', 'LR', 'UL', 'UR'].every((t) => this.model.teeth.includes(t))
        ? []
        : ['LL', 'LR', 'UL', 'UR']
      this.debounceSave()
    },
    drop(e) {
      e.preventDefault()
      if (e.dataTransfer) {
        this.$refs.attachments.$refs.upload.$refs.upload.addDataTransfer(e.dataTransfer)
      }
    },
    doctorAdded(data) {
      this.model.referring_doctor = data
      this.model.referring_doctor_id = data.id
      if (this.model.referring_doctor_id)
        this.$nextTick(() => {
          this.isAddDoctor = false
        })
      this.debounceSave()
    },
    phoneChange(e) {
      this.model.patient_phone = this.$options.filters.phone(e.target.value)
      this.debounceSave()
    },
    configureValidation(obj) {
      //todo: this doesnt work as expected. vee validate likely requires a remound/bind
      // other options are to manually handle the validation by attaching to each component - defeats vee validate
      VeeValidate.configure(obj)
    },
    referringDoctorChange() {
      this.model.referring_doctor = {
        ...this.practiceDoctors.find((s) => s.id == this.model.referring_doctor_id),
        is_doctor: true,
      }
      this.debounceSave()
    },
    async changePractice(p) {
      if (this.model.to_practice_id != p.id) {
        if (this.model.to_practice) {
          if (p?.specialty !== this.model.to_practice.specialty) {
            if (this.model.reasons?.length) {
              let dlgResult = false
              try {
                dlgResult = await this.$dialog.confirm(
                  {
                    title: 'Selected reasons will clear',
                    body: `You are changing practice specialties from <b>${
                      this.PracticeTypes[this.model.to_practice.specialty]
                    }</b> to <b>${
                      this.PracticeTypes[p.specialty]
                    }</b>.<br><br>As a result, your selected reasons <b>${this.modelReasons
                      .map((kv) => kv.value)
                      .join(
                        ', '
                      )}</b> will be cleared.<br><br>If you continue, please be sure to add a new reason for referral.`,
                  },
                  { okText: 'Clear & continue', cancelText: 'Go back' }
                )
              } catch {}
              if (!dlgResult) {
                return
              } else {
                // we could keep the reasons as is. they will not show but we could clear them on send.
                // this would allow users to switch practices and maintain any previosuly selected reasons.
                this.model.reasons = []
              }
            }
          }
        }
        this.model.to_practice = p
        this.model.to_practice_id = p.id
        this.model.doctor = 'Any (First Available)'
        this.save()
      }
      this.isChangePracticeShown = false
    },
  },
  // async beforeRouteLeave(to, from, next) {
  //   if (
  //     !this.isFormDirty ||
  //     (to.path.includes('referral') && to.params.id === this.model.id) ||
  //     (await this.warnDataLoss())
  //   ) {
  //     next()
  //   } else {
  //     next(false)
  //   }
  //},,
}
</script>
<style scoped lang="scss">
.jumbotron {
  background-color: #fff;
  text-align: center;
}

.form-check label {
  font-weight: normal;
}

.form-control.form-control-inline {
  width: auto;
  min-width: 0;
  display: inline-block;
}

ul.history {
  list-style-type: none;
  position: relative;
}

ul.history:before {
  content: ' ';
  background: #d4d9df;
  display: inline-block;
  position: absolute;
  left: 29px;
  width: 2px;
  height: 100%;
  z-index: 400;
}

ul.history > li {
  margin: 20px 0;
  padding-left: 20px;
}

ul.history > li:before {
  content: ' ';
  background: white;
  display: inline-block;
  position: absolute;
  border-radius: 50%;
  border: 3px solid #1cacda;
  left: 20px;
  width: 20px;
  height: 20px;
  z-index: 400;
}

ul.history > li:first-child:before {
  border-color: #96b647;
}

ul.history > li:first-child .badge-primary {
  font-size: 1.1em;
}

ul.history > li .badge {
  font-size: 1em;
}

ul.history > li.info:before {
  border: 3px solid #1cacda;
}

ul.history > li.primary:before {
  border: 3px solid #96b647;
}

ul.history > li.secondary:before {
  border: 3px solid #054065;
}

ul.history > li.danger:before {
  border: 3px solid #dc3545;
}

.d-within-input {
  position: absolute;
  top: 3em;
  right: 2em;
  z-index: 9;
}

.label-link {
  font-weight: bold;
  color: rgb(128, 130, 133);
  font-size: 1.25em;
  border-bottom: 2px solid #e6e7e8;
}

.label-link:hover,
.label-link.selected {
  color: #1cacda;
  border-bottom: 2px solid #1cacda;
}

.modal-header {
  padding: 0 0 0.5rem 0;
}

.modal-header h3 {
  font-size: 1.2rem;
}

@media (min-width: 576px) {
  .modal-header {
    padding: 0 0 1rem 0;
  }

  .modal-header h3 {
    font-size: 1.4875rem;
  }
}

.buttons .btn-lg {
  padding: 0.85rem 1.75rem;
}

h4 {
  font-size: 1.375rem;
}

label {
  font-weight: bolder;
  color: var(--body-color);
}

.fadeHeight-enter-active,
.fadeHeight-leave-active {
  transition: all 0.5s;
  max-height: 235px;
  opacity: 1;
}

.fadeHeight-enter,
.fadeHeight-leave-to {
  opacity: 0;
  max-height: 0px;
}

b {
  font-weight: 600;
}

.flex-width-equal > * {
  flex: 1;
  padding-right: 1rem;

  &:first-child {
    padding-left: 0;
  }

  &:last-child {
    padding-right: 0;
  }
}

.view-referral-wrapper {
  background: var(--light-color);

  .view-header {
    background: var(--border-color);
    display: flex;
    padding: 1rem 2rem;
    position: fixed;
    width: calc(100% - 350px);
    z-index: 8888;

    h3 {
      line-height: 2rem;
    }

    & > div {
      // flex: 1;
      padding-right: 1rem;

      &:first-child {
        padding-left: 0;
      }

      &:last-child {
        padding-right: 0;
      }
    }

    .btn-outline-primary {
      background-color: var(--light-color);

      &:hover {
        background-color: var(--primary-color);
        color: var(--light-color);
      }
    }
  }

  .referral-page-wrapper {
    padding: 0 0.25rem;
  }

  .friendly-text {
    font-family: Indie Flower;
    font-size: 1.35rem;
    position: absolute;
    margin-top: 30px;
    margin-left: 200px;
    width: calc(360px + 41px + 1rem);
    display: flex;

    &::before {
      background-image: url('data:image/svg+xml,%0A%3Csvg width="43" height="54" viewBox="0 0 43 54" fill="none" xmlns="http://www.w3.org/2000/svg"%3E%3Cpath d="M6.5 1.5C9.5 24.5 20 46.5 42 53.5" stroke="%23012B30" stroke-linejoin="round"/%3E%3Cpath d="M1 15L6 1L18.5 15" stroke="%23012B30" stroke-linejoin="round"/%3E%3C/svg%3E%0A');
      content: '';
      display: flex;
      background-size: 41px 53px;
      margin-right: 1rem;
      margin-top: -30px;
      width: 41px;
      height: 53px;
      // flex: 1;
      min-width: 41px;
    }
  }
}

.bottom-bar {
  background: #cbd9d9de;
  display: flex;
  padding: 1rem 2rem;
  padding-bottom: 0rem;
  position: fixed;
  bottom: 0;
  bottom: -70px;
  left: calc((100% - (1020px + 340px)) * -0.5);
  width: 100%;
  width: calc(100% - 350px);
  transition: background 0.5s ease-out;
  transition: bottom 0.5s ease-out;
  transition: max-height 0.5s ease-out;
  z-index: 4900; //behind sms container

  max-height: 150px;

  &:hover,
  &.searching {
    background: var(--border-color);
    bottom: 0;
  }

  &.searching {
    max-height: 620px;
  }
}

.with-sidebar {
  .bottom-bar {
    width: calc(100% - 350px - 50px);
  }
}

.edgeless {
  .bottom-bar {
    left: 0;
    left: 350px;
  }
}

.btn-light {
  &:not(:disabled):not(.disabled).active {
    border-color: #519f85;
  }

  &:focus:not(.active) {
    //prevent untoggle from looking toggled
    background-color: #eff3f3;
    border-color: #eff3f3;
  }
}

label {
  letter-spacing: -0.02rem;
  line-height: 1.2;
}

.practice-header {
  padding: 0rem;
  position: relative;

  .overlay-practice-header {
    display: none;
  }

  &.has-overlay:hover {
    margin: -2px;
    border: 2px dashed var(--border-color);
    border-radius: 5px;
    background: #f7f9f9;

    .overlay-practice-header {
      display: flex;
      cursor: pointer;
      position: absolute;
      width: 100%;
      margin-left: -2rem;
      border-radius: 5px;
      flex: 1 1 auto;
      z-index: 2;
      height: 100%;
      padding: 2rem;
      // background: #f7f9f979;
    }
  }
}

@media (min-width: 576px) {
  .view-referral-wrapper {
    .view-header {
      padding: 1.5rem 2.5rem;
    }
  }

  .referral-page-wrapper {
    padding: 0 2.5rem;
  }

  .practice-header {
    padding: 1rem;
    position: relative;
  }
}

@media print {
  .col-print-5 {
    flex: 0 0 41.6666666667% !important;
    max-width: 41.6666666667% !important;
  }

  .col-print-7 {
    flex: 0 0 58.3333333333% !important;
    max-width: 58.3333333333% !important;
  }

  .footer {
    position: fixed;
    /* <-- Key line */
    bottom: 00px;
    left: 0px;
    width: 100%;
  }

  .paper-shadow {
    box-shadow: none;
    border: 0;
  }
}
</style>
